import { privateApi } from 'services';

const saveOtysCredentials = async (businessAccountId: string, apiKey: string): Promise<void> =>
    privateApi.put<void>(
        `business-accounts/${businessAccountId}/connectors/otys/credentials`,
        { apiKey },
        undefined,
        true,
    );

export const OtysCredentialsGateway = {
    saveOtysCredentials,
};
